import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';

import { createRoot } from 'react-dom/client';
import React, { StrictMode } from 'react';
// import ReactDOM from 'react-dom';
import App from './App';
import Main from './Main';
import './helpers/initFA';

const rootElement = document.getElementById('main');
const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <Main>
      <App />
    </Main>
  </StrictMode>
);
